module.exports = {
  desktop: 'desktop',
  mobile: 'mobile',
  tablet: 'tablet',
};
